import { makeStyles } from 'tss-react/mui'
import _colors from 'styles/global/_colors'

export const useStyles = makeStyles()((theme) => ({
  error: {
    display: 'flex',
    marginTop: theme.spacing(2),
    background: `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), ${_colors.red}`,
    color: _colors.redDark,
    border: `1px solid ${_colors.red}`,
    borderRadius: '4px',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'fit-content',
    maxWidth: 'fit-content',
    whiteSpace: 'nowrap',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '16px',
  },
  icon: {
    marginRight: '8px',
    fontSize: '18px',
    color: `#a61b1b`, // Dark red icon color
  },
  correctionIcon: {
    marginRight: '8px',
    width: '20px',
    height: '20px',
  },
  errorMessageText: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    fontWeight: 500,
  },
}))
